import ActionButton from "./ActionButton";
import skipIcon from "../../assets/skip.svg";

function SkipButton(props) {
  return (
    <ActionButton
      {...props}
      icon={skipIcon}
      className="btn-skip"
      title="Skip"
    />
  );
}

export default SkipButton;